export var itemLayoutStyles = {
  root: function root(_ref) {
    var variables = _ref.variables;
    return {
      gridTemplateRows: "minmax(" + variables.height + ", max-content)",
      paddingLeft: variables.paddingLeft,
      paddingRight: variables.paddingRight
    };
  }
};